import { createContext, use, type ReactNode } from 'react';
import type { Ports } from '../lib/ports';

const PortsContext = createContext<Ports | null>(null);

export function PortsProvider({ ports, children }: { ports: Ports; children: ReactNode }) {
  return <PortsContext value={ports}>{children}</PortsContext>;
}

export function usePorts(): Ports {
  const ports = use(PortsContext);
  if (!ports) throw new Error('usePorts must be used inside <PortsProvider>');
  return ports;
}
